import {
  Box,
  Flex,
  Tooltip,
  Menu,
  MenuButton,
  MenuList,
} from '@chakra-ui/react';
import { useEditorToolbarConfig } from './useEditorToolbarConfig';
import { RiMore2Fill } from 'react-icons/ri';
import { colors } from '@/theme/foundations/colors';
import { DEFAULT_ATTACHMENT_FILES } from '@/constants/attachment-files';
export const EditorToolbar = ({
  editor,
  isTextSelected,
  toolbarWrapperStyles = {},
  pluginsConfig = ['link'],
  enableAllPlugins = true,
  disablePlugins = [],
  toolBarRef,
  imageConfig,
  setImageConfig,
  attachmentKey = 'attachments',
  attachmentFiles = DEFAULT_ATTACHMENT_FILES.join(','),
  disableConfig = undefined,
  isMaxImageCountExceeded,
  hasCodeBlock,
  onAttachmentChange,
  onAttachmentRemove,
  attachmentTooltipMessage,
  totalSizeLimitMB,
  hideToolbar = false,
  onSurveySelect,
  onSurveyRemove,
}) => {
  const { defaultEditorConfig, additionalPlugins } = useEditorToolbarConfig({
    isTextSelected,
    editor,
    pluginsConfig,
    imageConfig,
    setImageConfig,
    attachmentKey,
    attachmentFiles,
    disableConfig,
    isMaxImageCountExceeded,
    hasCodeBlock,
    onAttachmentChange,
    onAttachmentRemove,
    attachmentTooltipMessage,
    totalSizeLimitMB,
    onSurveySelect,
    onSurveyRemove,
  });

  if (!editor || hideToolbar) {
    return null;
  }

  const visibleIcons = (
    enableAllPlugins && pluginsConfig.length === 0
      ? [...defaultEditorConfig].slice(0, 3)
      : [...defaultEditorConfig.slice(0, 3), ...additionalPlugins]
  ).filter((item) => item && !disablePlugins.includes(item.id));

  const menuIcons = defaultEditorConfig
    .slice(3)
    .filter((item) => item && !disablePlugins.includes(item.id));

  const renderFilterIcons = (item, index) => {
    const {
      id,
      title,
      onClick = () => {},
      styles,
      icon,
      color,
      Component,
      props,
      isActive,
    } = item;

    const isHighlight =
      !isTextSelected &&
      ![
        'alignLeft',
        'alignRight',
        'paragraph',
        'heading1',
        'heading2',
        'heading3',
        'heading4',
        'unorderedList',
        'orderedList',
        'table',
      ].includes(id);

    if (Component)
      return (
        <Component
          key={`${index}-${id}`}
          icon={icon}
          editor={editor}
          isActive={isActive}
          isTextSelected={isTextSelected}
          {...props}
        />
      );
    return (
      <Tooltip
        key={`${index}-${id}`}
        label={title}
        arrowSize={8}
        hasArrow
        placement="top"
        variant="ats-primary"
        borderRadius="4px"
      >
        <Box
          display="inline-flex"
          role="button"
          onClick={(event) => {
            // event.stopPropagation();
            onClick?.();
          }}
          borderRadius="6px"
          cursor="pointer"
          p="8px"
          color={color}
          bg={isActive ? '#e0e0e0' : 'transparent'}
          opacity={isHighlight ? 0.5 : 1}
          pointerEvents={isHighlight ? 'none' : 'auto'}
          data-test-id={`editor-toolbar-${id}-button`}
          {...styles}
        >
          {icon}
        </Box>
      </Tooltip>
    );
  };

  return (
    <Flex
      {...toolbarWrapperStyles}
      gap="2px"
      pl="5px"
      flexWrap="wrap"
      alignItems="center"
      ref={toolBarRef}
    >
      {visibleIcons.map(renderFilterIcons)}
      <Menu gutter={0} offset={[0, 0]}>
        <Tooltip
          label={'More'}
          arrowSize={8}
          hasArrow
          placement="top"
          variant="ats-primary"
          borderRadius="4px"
        >
          <MenuButton
            as={Box}
            role="button"
            borderRadius="6px"
            cursor="pointer"
            p="8px"
            opacity={1}
            onClick={() => {
              const { empty } = editor.state.selection;
              if (!empty) {
                editor.commands.focus();
              }
            }}
          >
            {/* @ts-ignore */}
            <RiMore2Fill color={colors['secondary-700']} size="16px" />
          </MenuButton>
        </Tooltip>
        <MenuList
          minW="auto"
          maxH="250px"
          overflowY="auto"
          display="flex"
          gap="6px"
          zIndex={99999}
        >
          {menuIcons.map(renderFilterIcons)}
        </MenuList>
      </Menu>
    </Flex>
  );
};
